import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { OsUpdate } from '@era/osupdates-sdk';
import { AvailableOsUpdatesStoreActions, AvailableOsUpdatesStoreSelectors } from '../available-os-updates';

@Injectable()
export class AvailableOsUpdatesResolver {
  constructor(private readonly store: Store<OsUpdate>) {}

  resolve(): Observable<boolean> {
    return this.store.select(AvailableOsUpdatesStoreSelectors.selectAvailableOsUpdatesLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(
            AvailableOsUpdatesStoreActions.AvailableOsUpdatesResolverActions.availableOsUpdatesRequested()
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
